import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentMeSiblingUser on User {
    id
    firstName
    lastName
  }
`
